/**
 * List of available teasers. the order of this object is also
 * the order of prioritization in terms of queueing / initial load
 */
export const TEASERS_TYPES = {
    COMPLIANCE: 'COMPLIANCE',
    SAML_ONBOARDING: 'SAML_ONBOARDING',
    PIONEER_AMBASSADOR: 'PIONEER_AMBASSADOR'
} as const;

export const COMPLIANCE_MESSAGE_CLOSED_KEY = 'compliance_message_accepted';
export const SKIPPED_PIONEER_AMBASSADOR_TEASER = 'pioneers_teaser_shown';
export const SKIPPED_PIONEER_AMBASSADOR_TEASER_TIME = { months: 6 };
